import React, { ChangeEvent } from 'react';
import { Select, Input } from 'common/components';

import styles from '../../NodeConfigModal.module.scss';

interface NodeConfigDelayProps {
    delayType: 'TIMESTAMP' | 'DURATION';
    timeValue: string;
    timeUnit: 'minutes' | 'hours' | 'days';
    specificDateTime: string;
    onDelayTypeChange: (value: 'TIMESTAMP' | 'DURATION') => void;
    onTimeValueChange: (value: string) => void;
    onTimeUnitChange: (value: 'minutes' | 'hours' | 'days') => void;
    onSpecificDateTimeChange: (value: string) => void;
}

export const NodeConfigDelay: React.FC<NodeConfigDelayProps> = ({
    delayType,
    timeValue,
    timeUnit,
    specificDateTime,
    onDelayTypeChange,
    onTimeValueChange,
    onTimeUnitChange,
    onSpecificDateTimeChange,
}) => {
    return (
        <>
            <div>
                <div className={styles.formGroup}>
                    <label className={styles.groupLabel}>Delay Type</label>
                    <div className={styles.radioGroup}>
                        <label className={styles.radioLabel}>
                            <input
                                type='radio'
                                name='delay-type'
                                value='TIMESTAMP'
                                checked={delayType === 'TIMESTAMP'}
                                onChange={() => onDelayTypeChange('TIMESTAMP')}
                                className={styles.radio}
                            />
                            <span>Specific Date/Time</span>
                        </label>
                        <label className={styles.radioLabel}>
                            <input
                                type='radio'
                                name='delay-type'
                                value='DURATION'
                                checked={delayType === 'DURATION'}
                                onChange={() => onDelayTypeChange('DURATION')}
                                className={styles.radio}
                            />
                            <span>Duration</span>
                        </label>
                    </div>
                </div>
            </div>

            {delayType === 'DURATION' ? (
                <div className={styles.durationSection}>
                    <div>
                        <Input
                            id='time-value'
                            label='Time Value'
                            type='number'
                            value={timeValue}
                            onChange={(e: ChangeEvent<HTMLInputElement>) => onTimeValueChange(e.target.value)}
                            placeholder='e.g. 30'
                            min='1'
                        />
                    </div>
                    <div>
                        <Select
                            id='time-unit'
                            label='Time Unit'
                            value={timeUnit}
                            onChange={(e: ChangeEvent<HTMLSelectElement>) =>
                                onTimeUnitChange(e.target.value as 'minutes' | 'hours' | 'days')
                            }
                            options={[
                                { value: 'minutes', label: 'Minutes' },
                                { value: 'hours', label: 'Hours' },
                                { value: 'days', label: 'Days' },
                            ]}
                        />
                    </div>
                </div>
            ) : (
                <div>
                    <Input
                        id='specific-datetime'
                        label='Select Date/Time'
                        type='datetime-local'
                        value={specificDateTime.slice(0, 16)}
                        onChange={(e: ChangeEvent<HTMLInputElement>) => {
                            const newDate = new Date(e.target.value);
                            onSpecificDateTimeChange(newDate.toISOString());
                        }}
                    />
                </div>
            )}
        </>
    );
};
